<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="24" :md="22" :lg="20" :xl="16">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            size="large"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-tabs v-model="activeLang" class="lang-tabs">
                <el-tab-pane name="uz_lat">
                  <template #label>
                    <span class="lang-tab-label" :class="{'lang-tab-label--error': langErrors.includes('uz_lat')}">
                      UZ
                      <span v-if="!form.title_lang.uz_lat" class="lang-tab-dot" title="Bo'sh"/>
                    </span>
                  </template>
                  <el-form-item label="Qator sarlavhasi (UZ)" prop="title_lang.uz_lat">
                    <el-input
                        v-model="form.title_lang.uz_lat"
                        placeholder="Qator sarlavhasi"
                        @input="clearLangError('uz_lat')"
                    />
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane name="uz_cyr">
                  <template #label>
                    <span class="lang-tab-label" :class="{'lang-tab-label--error': langErrors.includes('uz_cyr')}">
                      UZ Krill
                      <span v-if="!form.title_lang.uz_cyr" class="lang-tab-dot" title="Bo'sh"/>
                    </span>
                  </template>
                  <el-form-item label="Qator sarlavhasi (UZ Krill)" prop="title_lang.uz_cyr">
                    <el-input
                        v-model="form.title_lang.uz_cyr"
                        placeholder="Qator sarlavhasi"
                        @input="clearLangError('uz_cyr')"
                    />
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane name="ru">
                  <template #label>
                    <span class="lang-tab-label" :class="{'lang-tab-label--error': langErrors.includes('ru')}">
                      RU
                      <span v-if="!form.title_lang.ru" class="lang-tab-dot" title="Bo'sh"/>
                    </span>
                  </template>
                  <el-form-item label="Qator sarlavhasi (RU)" prop="title_lang.ru">
                    <el-input
                        v-model="form.title_lang.ru"
                        placeholder="Qator sarlavhasi"
                        @input="clearLangError('ru')"
                    />
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane name="en">
                  <template #label>
                    <span class="lang-tab-label">
                      EN
                      <span v-if="!form.title_lang.en" class="lang-tab-dot" title="Bo'sh"/>
                    </span>
                  </template>
                  <el-form-item label="Qator sarlavhasi (EN)" prop="title_lang.en">
                    <el-input v-model="form.title_lang.en" placeholder="Qator sarlavhasi"/>
                  </el-form-item>
                </el-tab-pane>
                <el-tab-pane name="kr">
                  <template #label>
                    <span class="lang-tab-label">
                      KR
                      <span v-if="!form.title_lang.kr" class="lang-tab-dot" title="Bo'sh"/>
                    </span>
                  </template>
                  <el-form-item label="Qator sarlavhasi (KR)" prop="title_lang.kr">
                    <el-input v-model="form.title_lang.kr" placeholder="Qator sarlavhasi"/>
                  </el-form-item>
                </el-tab-pane>
              </el-tabs>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="Qator raqami" prop="row_number">
                <el-input-number placeholder="Qator raqami" controls-position="right" class="form-input"
                                 v-model="form.row_number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="1-chorak" prop="quarter_1">
                <el-input-number placeholder="1-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_1"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="2-chorak" prop="quarter_2">
                <el-input-number placeholder="2-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_2"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="3-chorak" prop="quarter_3">
                <el-input-number placeholder="3-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_3"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="4-chorak" prop="quarter_4">
                <el-input-number placeholder="4-chorak" controls-position="right" class="form-input"
                                 v-model="form.quarter_4"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <el-form-item label="Yillik" prop="annual">
                <el-input-number placeholder="Yillik" controls-position="right" class="form-input"
                                 v-model="form.annual"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="()=>this.$router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

// Admin panel'ning yagona ishlaydigan interfeys tili — hozircha til
// almashtirgich yo'q (moment.locale ham hardcoded 'uz'), shuning uchun
// state-budget-row-multilang-admin.md talab qilgan "joriy til" shu.
const HL_HEADER = {hl: "uz_lat"};

function emptyTitleLang() {
  return {uz_lat: "", uz_cyr: "", ru: "", en: "", kr: ""};
}

export default {
  name: "StateBudgetRowForm",
  data() {
    return {
      loading: false,
      editId: null,
      activeLang: "uz_lat",
      langErrors: [],
      form: {
        state_budget_id: null,
        parent: null,
        row_number: null,
        title_lang: emptyTitleLang(),
        quarter_1: null,
        quarter_2: null,
        quarter_3: null,
        quarter_4: null,
        annual: null
      },
      rules: {
        "title_lang.uz_lat": [
          {required: true, message: "Majburiy maydon (UZ)", trigger: 'blur'}
        ],
        "title_lang.uz_cyr": [
          {required: true, message: "Majburiy maydon (UZ Krill)", trigger: 'blur'}
        ],
        "title_lang.ru": [
          {required: true, message: "Majburiy maydon (RU)", trigger: 'blur'}
        ],
        row_number: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_1: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_2: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_3: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        quarter_4: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        annual: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    clearLangError(code) {
      this.langErrors = this.langErrors.filter((c) => c !== code);
    },
    getStateBudgetRow() {
      this.loading = true
      this.$http.get(`api/v1/state-budget-row/${this.editId}`, {headers: HL_HEADER}).then(({data}) => {
        this.form = {
          state_budget_id: data.state_budget_id,
          parent: data.parent,
          row_number: data.row_number,
          title_lang: {...emptyTitleLang(), ...data.title_lang},
          quarter_1: data.quarter_1,
          quarter_2: data.quarter_2,
          quarter_3: data.quarter_3,
          quarter_4: data.quarter_4,
          annual: data.annual,
        }
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },
    onSubmit() {
      this.langErrors = [];
      this.$refs.form.validate((valid, invalidFields) => {
        if (!valid) {
          if (invalidFields) {
            this.langErrors = Object.keys(invalidFields)
                .filter((key) => key.startsWith("title_lang."))
                .map((key) => key.split(".")[1]);
            const firstInvalidLang = this.langErrors[0];
            if (firstInvalidLang) this.activeLang = firstInvalidLang;
          }
          return;
        }

        this.loading = true;

        const formData = {
          state_budget_id: this.form.state_budget_id,
          parent: this.form.parent,
          row_number: this.form.row_number,
          title_lang: {...this.form.title_lang},
          quarter_1: this.form.quarter_1,
          quarter_2: this.form.quarter_2,
          quarter_3: this.form.quarter_3,
          quarter_4: this.form.quarter_4,
          annual: this.form.annual,
        };

        let http;
        if (this.editId) {
          http = this.$http.put(`/api/v1/state-budget-row/${this.editId}`, formData, {headers: HL_HEADER});
        } else {
          http = this.$http.post('/api/v1/state-budget-row', formData, {headers: HL_HEADER});
        }

        http.then(() => {
          ElNotification({
            title: 'Tabriklaymiz',
            message: 'Muvafaqiyatli saqlandi',
            type: 'success',
          })
          this.$router.go(-1)
        }).catch(({response}) => {
          ElNotification({
            title: 'Xatolik',
            message: response.data.message || "Iltimos, qayta urinib ko'ring.",
            type: 'error',
          })
        }).finally(() => {
          this.loading = false
        })
      })
    },
  },
  mounted() {

    if (this.$route.query.state_budget_id) {
      this.form.state_budget_id = parseInt(this.$route.query.state_budget_id)
    }
    if (this.$route.query.parent_id) {
      this.form.parent = parseInt(this.$route.query.parent_id)
    }
    if (this.$route.params.id) {
      this.editId = this.$route.params.id
      this.getStateBudgetRow()
    }
  }
}
</script>

<style scoped>
.form-input {
  width: 100%;
}

.lang-tabs {
  margin-bottom: 6px;
}

.lang-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.lang-tab-label--error {
  color: #f56c6c;
}

.lang-tab-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e6a23c;
  flex-shrink: 0;
}
</style>
